import React from 'react';
import './salesTeam info.css'
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBModal, MDBModalHeader, MDBModalBody } from "mdbreact";
import "react-image-gallery/styles/css/image-gallery.css";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import allStrings from "../../assets/strings";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { BASE_END_POINT } from "../../urls";
import axios from "axios";
import { hasValue } from "../../validations/validations";
import { message, Spin, Empty, TreeSelect, DatePicker, Popconfirm } from "antd";
import Tooltip from '@material-ui/core/Tooltip';
import CloseIcon from '@material-ui/icons/Close';
import Skeleton from 'react-loading-skeleton';
import PaginationButtons from '../../component/pagenation/pagenation';
import moment from 'moment';
import 'moment/locale/ar';
const TreeNode = TreeSelect

class SalesTeamInfo extends React.Component {
  state = {
    actionType: this.props.location.state.actionType ? this.props.location.state.actionType === "EDIT" ? "EDIT" : "VIEW" : "VIEW",
    id: this.props.location.state.data.id,
    name: this.props.location.state.data.name ? this.props.location.state.data.name : "",
    leader: this.props.location.state.data.leader ? this.props.location.state.data.leader.id : null,
    members: this.props.location.state.data.members ? this.props.location.state.data.members : [],
    member: null,
    targets: [],
    loading: true,
    refresh: false,
    page: 1,
    pages: 1,
    modal: false,
    targetModal: false,
    employees: [],
    target: 0,
    date: null,
  };

  constructor(props) {
    super(props)
    console.log('props ', props)
    window.scrollTo(0, 0)
    this.getUserWithoutPagenation()
    this.getSalesTeamTargets(1, false)
    if (this.props.isRTL) {
      allStrings.setLanguage('ar')
    } else {
      allStrings.setLanguage('en')
    }
  }
  componentDidMount() {
    if (this.props.isRTL) {
      allStrings.setLanguage('ar')
    } else {
      allStrings.setLanguage('en')
    }
  }
  getUserWithoutPagenation = () => {
    axios.get(`${BASE_END_POINT}quickSearch/get?type=SUB-ADMIN`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en',
      },
    }).then(response => {
      console.log(response.data.data)
      this.setState({ employees: response.data.data })
    })
      .catch(error => {
        console.log("ALL employees ERROR")
        console.log(error.response)
      })
  }
  getSalesTeamTargets = (page, refresh) => {
    this.setState({ loading: true })
    axios.get(`${BASE_END_POINT}salesTeams/${this.state.id}/targets?page=${page}`, {
      headers: {
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en'
      }
    })
      .then(response => {
        console.log("targets   ", response.data)
        this.setState({
          loading: false,
          refresh: false,
          targets: response.data.data,
          page: response.data.page,
          pages: response.data.pageCount,
        })
      })
      .catch(error => {
        console.log("error   ", error.response)
        console.log("error2   ", error)
        this.setState({ loading: false, })
      })

  }
  removeTarget = (id) => {
    let l = message.loading('Wait..', 2.5)
    axios.delete(`${BASE_END_POINT}salesTeams/${this.state.id}/targets/${id}/removeTarget`, {
      headers: {
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en'
      }
    })
      .then(response => {
        console.log("target REMOVED")
        l.then(() => message.success(allStrings.done, 2.5))
        this.getSalesTeamTargets(this.state.page, false)
      })
      .catch(error => {
        console.log("error   ", error.response)
        console.log("error2   ", error)
        l.then(() => message.error(allStrings.error, 2.5))
      })
  }
  addTarget = () => {
    const { target, date } = this.state
    if (date !== null) {
      let l = message.loading('Wait..', 2.5)
      let data = {
        target: target,
        date: date
      }
      axios.post(`${BASE_END_POINT}salesTeams/${this.state.id}/addTarget`, JSON.stringify(data), {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.props.currentUser.token}`,
          'Accept-Language': this.props.isRTL ? 'ar' : 'en'
        },
      })
        .then(response => {
          console.log("target ADDED  ", response.data)
          l.then(() => message.success(allStrings.done, 2.5))
          this.setState({ targetModal: false, target: '', date: null })
          this.getSalesTeamTargets(this.state.page, false)
        })
        .catch(error => {
          console.log("error   ", error.response)
          console.log("error2   ", error)
          l.then(() => message.error(allStrings.error, 2.5))
        })
    }
  }
  update = () => {
    const { name, leader } = this.state
    if (hasValue(name) && leader !== null) {
      let l = message.loading('Wait..', 2.5)
      let data = new FormData()
      data.append('name', name)
      data.append('leader', leader)
      axios.put(`${BASE_END_POINT}salesTeams/${this.props.location.state.data.id}`, JSON.stringify(data), {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.props.currentUser.token}`,
          'Accept-Language': this.props.isRTL ? 'ar' : 'en'
        },
      })
        .then(response => {
          console.log(" salesTeams UPDATED  ", response.data)
          l.then(() => message.success(allStrings.done, 2.5))
          this.props.history.goBack()
        })
        .catch(error => {
          console.log(error.response)
          l.then(() => message.error(allStrings.error, 2.5))
        })
    }
  }
  removeMember = (id) => {
    let l = message.loading('Wait..', 2.5)
    axios.delete(`${BASE_END_POINT}salesTeams/${this.props.location.state.data.id}/salesTeam/${id}/removeMember`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en'
      },
    })
      .then(response => {
        console.log("ROW DELETED")
        l.then(() => message.success(allStrings.done, 2.5))
        this.props.history.goBack()
      })
      .catch(error => {
        console.log(error.response)
        l.then(() => message.error(allStrings.error, 2.5))
      })
  }
  addMember = () => {
    let l = message.loading('Wait..', 2.5)
    axios.post(`${BASE_END_POINT}salesTeams/${this.props.location.state.data.id}/addMember`, { member: this.state.member }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en'
      },
    })
      .then(response => {
        console.log("ROW ADDED")
        this.setState({ modal: false, member: null })
        l.then(() => message.success(allStrings.done, 2.5))
        this.props.history.goBack()
      })
      .catch(error => {
        console.log(error.response)
        l.then(() => message.error(allStrings.error, 2.5))
      })
  }

  delete = () => {
    let l = message.loading('Wait..', 2.5)
    axios.delete(`${BASE_END_POINT}salesTeams/${this.props.location.state.data.id}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en'
      },
    })
      .then(response => {
        console.log("ROW DELETED")
        l.then(() => message.success(allStrings.done, 2.5))
        this.props.history.goBack()
      })
      .catch(error => {
        console.log(error.response)
        l.then(() => message.error(allStrings.error, 2.5))
      })
  }



  submitHandler = event => {
    event.preventDefault();
    event.target.className += " was-validated";
    this.update()
  };

  changeHandler = event => {
    this.setState({ [event.target.name]: event.target.value });
  };
  submitHandlerAddMember = (event) => {
    event.preventDefault();
    event.target.className += " was-validated";
    this.addMember()
  };

  membersTable = () => {
    return (
      <MDBRow>
        <MDBCol md="12">
          <div className="infoTable">
            <div className="topInfoTable" style={{ background: "#1D9598" }}>
              <h4>
                {allStrings.members}
              </h4>
            </div>
            <div className="tableDate">
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    {this.props.isRTL ?
                      <tr style={{ textAlign: 'center' }}>
                        <th>{allStrings.more}</th>
                        <th>{allStrings.name}</th>
                        <th scope="col">#</th>
                      </tr>
                      :
                      <tr style={{ textAlign: 'center' }}>
                        <th scope="col">#</th>
                        <th>{allStrings.name}</th>
                        <th>{allStrings.more}</th>
                      </tr>
                    }

                  </thead>
                  <tbody>
                    {this.state.loading ?
                      <tr style={{ height: '200px' }}>
                        <th colSpan={this.state.tableType === "collected" ? "5" : "4"} className="noData">
                          <Skeleton height={400} />
                        </th>
                      </tr>
                      :
                      this.state.members.length > 0 ?
                        this.state.members.map(val => (
                          this.props.isRTL ?
                            <tr style={{ textAlign: 'center' }}>
                              <td>
                                <span style={{ margin: "4px", cursor: 'pointer' }}>
                                  <Tooltip title={allStrings.areYouSureDelete} placement="top">
                                    <Popconfirm
                                      title={allStrings.areYouSureDelete}
                                      okText={allStrings.yes}
                                      cancelText={allStrings.no}
                                      onConfirm={() => {
                                        this.removeMember(val.id)
                                      }}
                                    >
                                      <CloseIcon color="secondary" style={{ fontSize: '22px' }} />
                                    </Popconfirm>
                                  </Tooltip>
                                </span>
                              </td>
                              <td>{val.fullname}</td>
                              <td >{val.id}</td>
                            </tr>
                            :
                            <tr style={{ textAlign: 'center' }}>
                              <td >{val.id}</td>
                              <td>{val.fullname}</td>
                              <td>
                                <span style={{ margin: "4px", cursor: 'pointer' }}>
                                  <Tooltip title={allStrings.areYouSureDelete} placement="top">
                                    <Popconfirm
                                      title={allStrings.areYouSureDelete}
                                      okText={allStrings.yes}
                                      cancelText={allStrings.no}
                                      onConfirm={() => {
                                        this.removeMember(val.id)
                                      }}
                                    >
                                      <CloseIcon color="secondary" style={{ fontSize: '22px' }} />
                                    </Popconfirm>
                                  </Tooltip>
                                </span>
                              </td>
                            </tr>
                        ))
                        :
                        <tr style={{ height: '200px' }}>
                          <th colSpan="12" className="noData">
                            <Empty description={allStrings.noData} style={{ margin: '0rem' }} />
                          </th>
                        </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </MDBCol>
      </MDBRow>
    )
  }

  toggle = () => {
    this.setState({
      modal: !this.state.modal,
    });
  }
  modal = () => (
    <MDBModal isOpen={this.state.modal} toggle={this.toggle} size="lg">
      <MDBModalHeader toggle={this.toggle} >{allStrings.completeData}</MDBModalHeader>
      <MDBModalBody>
        <MDBContainer>
          <MDBRow>
            <MDBCol md="12">
              <form style={{ paddingTop: '1rem' }}
                className="needs-validation"
                onSubmit={this.submitHandlerAddMember}
                noValidate
              >
                <div className="grey-text">
                  <MDBRow>
                    <MDBCol md="12">
                      <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.member}</label>
                      <TreeSelect virtual={false}
                        showSearch={true}
                        style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                        treeCheckable={false}
                        treeNodeFilterProp="title"
                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                        placeholder={allStrings.member}
                        onChange={(value) => {
                          console.log(value)
                          this.setState({ member: value });
                        }}

                      >
                        {this.state.employees.map(val => (
                          <TreeNode value={val.id} title={val.fullname} key={val.id} />
                        ))}
                      </TreeSelect>
                    </MDBCol>
                  </MDBRow>

                </div>
                <div className="drawer-action-footer">
                  <MDBBtn type="button" className="btn-cancel" onClick={this.toggle}>
                    إلغاء
                  </MDBBtn>
                  <MDBBtn type="submit" className="btn-submit">
                    {allStrings.add}
                  </MDBBtn>
                </div>
              </form>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </MDBModalBody>
    </MDBModal>
  );
  salesTeamTargetsTable = () => {
    return (
      <MDBRow>
        <MDBCol md="12">
          <div className="infoTable">
            <div className="topInfoTable" style={{ background: "#1D9598" }}>
              <h4>
                {allStrings.targets}
              </h4>
            </div>
            <div className="tableDate">
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    {this.props.isRTL ?
                      <tr style={{ textAlign: 'center' }}>
                        <th>{allStrings.more}</th>
                        <th>{allStrings.date}</th>
                        <th>{allStrings.target}</th>
                      </tr>
                      :
                      <tr style={{ textAlign: 'center' }}>
                        <th>{allStrings.target}</th>
                        <th>{allStrings.date}</th>
                        <th>{allStrings.more}</th>
                      </tr>
                    }
                  </thead>
                  <tbody>
                    {this.state.loading ?
                      <tr>
                        <th colSpan="12" className="noData">
                          <Skeleton height={40} />
                        </th>
                      </tr>
                      :
                      this.state.targets.length > 0 ?
                        this.state.targets.map((val, index) => (
                          this.props.isRTL ?
                            <tr key={index} style={{ textAlign: 'center' }}>
                              <td>
                                <span style={{ margin: "4px", cursor: 'pointer' }} >
                                  <Tooltip title={allStrings.areYouSureDelete} placement="top">
                                    <Popconfirm
                                      title={allStrings.areYouSureDelete}
                                      okText={allStrings.yes}
                                      cancelText={allStrings.no}
                                      onConfirm={() => {
                                        this.removeTarget(val.id)
                                      }}
                                    >
                                      <CloseIcon color="secondary" style={{ fontSize: '22px' }} />
                                    </Popconfirm>
                                  </Tooltip>
                                </span>
                              </td>
                              <td >{moment(val.date).locale('ar').format('ll')}</td>
                              <td>{val.target}</td>
                            </tr>
                            :
                            <tr key={index} style={{ textAlign: 'center' }}>
                              <td>{val.target}</td>
                              <td >{moment(val.date).locale('ar').format('ll')}</td>
                              <td>
                                <span style={{ margin: "4px", cursor: 'pointer' }} >
                                  <Tooltip title={allStrings.areYouSureDelete} placement="top">
                                    <Popconfirm
                                      title={allStrings.areYouSureDelete}
                                      okText={allStrings.yes}
                                      cancelText={allStrings.no}
                                      onConfirm={() => {
                                        this.removeTarget(val.id)
                                      }}
                                    >
                                      <CloseIcon color="secondary" style={{ fontSize: '22px' }} />
                                    </Popconfirm>
                                  </Tooltip>
                                </span>
                              </td>
                            </tr>
                        ))
                        :
                        <tr style={{ height: '200px' }}>
                          <th colSpan="12" className="noData">
                            <Empty description={allStrings.noData} style={{ margin: '0rem' }} />
                          </th>
                        </tr>
                    }
                  </tbody>
                </table>
                {this.state.targets.length > 0 &&
                  <div style={{ textAlign: 'center', margin: 'auto', marginTop: '3rem' }}>
                    <PaginationButtons
                      page={this.state.page}
                      pages={this.state.pages}
                      labels={allStrings}
                      onPageChange={(newPage) => {
                        this.getSalesTeamTargets(newPage);
                        this.setState({ page: newPage });
                      }}
                    />
                  </div>
                }
              </div>
            </div>
          </div>
        </MDBCol>
      </MDBRow>
    )
  }
  submitHandlerAddTarget = (event) => {
    event.preventDefault();
    event.target.className += " was-validated";
    this.addTarget()
  };
  toggleTarget = () => {
    this.setState({
      targetModal: !this.state.targetModal,
    });
  }
  targetModal = () => (
    <MDBModal isOpen={this.state.targetModal} toggle={this.toggleTarget} size="lg">
      <MDBModalHeader toggle={this.toggleTarget}>{allStrings.completeData}</MDBModalHeader>
      <MDBModalBody>
        <MDBContainer>
          <MDBRow>
            <MDBCol md="12">
              <form
                onSubmit={this.submitHandlerAddTarget}
                noValidate
              >
                <div className="grey-text">
                  <MDBRow>
                    <MDBCol md="12">
                      <div className="md-form">
                        <label htmlFor="form8" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.target}</label>
                        <input name='target' style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} type="number" min={0} id="form8" className="form-control" onChange={this.changeHandler} required validate placeholder="أدخل الهدف..." />
                        <div class="valid-feedback">{allStrings.correct}</div>
                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                      </div>
                    </MDBCol>
                  </MDBRow>
                  <MDBRow>
                    <MDBCol md="12">
                      <div className="md-form">
                        <label htmlFor="form8" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.date}</label>
                        <DatePicker
                          dropdownAlign={{ points: ['bl', 'tl'] }}
                          placement="topLeft"
                          style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', marginBottom: '1rem' }}
                          onChange={(date, dateString) => {
                            this.setState({ date: dateString })
                          }}
                          placeholder={allStrings.date}
                        />
                      </div>
                    </MDBCol>
                  </MDBRow>

                </div>
                <div className="drawer-action-footer">
                  <MDBBtn type="button" className="btn-cancel" onClick={this.toggleTarget}>
                    إلغاء
                  </MDBBtn>
                  <MDBBtn type="submit" className="btn-submit">
                    {allStrings.add}
                  </MDBBtn>
                </div>
              </form>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </MDBModalBody>
    </MDBModal>
  )
  render() {
    if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('SALES-TEAMS')) return <Redirect to='/Home' />
    return (
      <div className="App">
        {this.modal()}
        {this.targetModal()}
        <Spin spinning={this.state.loading} tip={allStrings.loading} size="large" style={{ color: '#1D9598' }}>
          <MDBContainer>
            {this.state.actionType === "VIEW" &&
              <MDBRow style={{ flexFlow: this.props.isRTL ? 'row-reverse' : 'row' }} >
                <MDBCol md='12'>
                  <MDBBtn onClick={() => { this.delete() }} rounded style={{ display: 'inline-block', width: 'fit-content', margin: '8px', background: 'linear-gradient(135deg, #FF3547, #B71C1C)', color: '#fff', borderRadius: '10px' }} color="FF3547" className="btn-block z-depth-1a">
                    <MDBIcon icon="trash-alt" className="mr-2" />
                    {allStrings.remove}
                  </MDBBtn>
                  <MDBBtn
                    onClick={() => { this.toggle() }}
                    color="none"
                    style={{ display: 'inline-block', width: 'fit-content', margin: '8px', padding: '10px', background: '#fff', color: '#127275', borderRadius: '10px', border: '1px solid #127275' }}
                    rounded
                    className="btn-block z-depth-1a"
                  >
                    <MDBIcon icon="plus" className="mr-2" />
                    {allStrings.addMember}
                  </MDBBtn>
                  <MDBBtn
                    onClick={() => { this.toggleTarget() }}
                    color="none"
                    style={{ display: 'inline-block', width: 'fit-content', margin: '8px', padding: '10px', background: '#fff', color: '#127275', borderRadius: '10px', border: '1px solid #127275' }}
                    rounded
                    className="btn-block z-depth-1a"
                  >
                    <MDBIcon icon="plus" className="mr-2" />
                    {allStrings.addTarget}
                  </MDBBtn>
                </MDBCol>
              </MDBRow>
            }
            <MDBRow>
              <MDBCol xl="12" lg="12" md="12" sm="12">
                <div className="infoCard">
                  <Card className="editCard" style={{ overflow: 'visible', outline: 'none', marginBottom: '0px' }}>
                    <CardMedia
                      style={{ height: "0px" }}
                    />
                    <CardHeader></CardHeader>
                    <div style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row', display: 'flex' }}>
                      <div className="topIcon" style={{ background: 'linear-gradient(135deg, #1D9598, #127275)' }}>
                        <span className="material-icons" style={{ color: 'white', fontSize: 20 }}>contact_phone</span>
                      </div>
                      <div className="tableTitle" style={{
                        display: 'inline-block', marginTop: '-60px',
                        marginLeft: '0', marginRight: '0'
                      }}>
                        <p>{this.state.actionType === "VIEW" ? allStrings.info : allStrings.edit}</p>
                      </div>
                    </div>
                    <CardContent style={{ minHeight: "390px", outline: 'none' }}>
                      <MDBContainer>
                        <MDBRow>
                          <MDBCol md="12">
                            <form
                              className="needs-validation"
                              onSubmit={this.submitHandler}
                              noValidate
                            >

                              <div className="grey-text">
                                {this.state.actionType === "VIEW" &&
                                  <MDBRow>
                                    <MDBCol md="12">
                                      <div className="md-form">
                                        <label htmlFor="form8" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>#</label>
                                        <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} defaultValue={this.state.id} type="text" id="form8" className="form-control" onChange={this.changeHandler} required validate />
                                        <div class="valid-feedback">{allStrings.correct}</div>
                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                      </div>
                                    </MDBCol>
                                  </MDBRow>
                                }
                                <MDBRow>
                                  <MDBCol md="6">
                                    <div className="md-form">
                                      <label htmlFor="form65" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.name}</label>
                                      <input disabled={this.state.actionType === "VIEW" ? true : false} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} defaultValue={this.state.name} type="text" id="form65" name="name" className="form-control" onChange={this.changeHandler} validate placeholder="أدخل الاسم..." />
                                      <div class="valid-feedback">{allStrings.correct}</div>
                                      <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                    </div>
                                  </MDBCol>
                                  <MDBCol md="6">
                                    <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.leader}</label>
                                    <TreeSelect virtual={false}
                                      showSearch={true}
                                      style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                                      treeCheckable={false}
                                      disabled={this.state.actionType === "VIEW" ? true : false}
                                      value={this.state.leader}
                                      treeNodeFilterProp="title"
                                      dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                      placeholder={allStrings.leader}
                                      onChange={(value) => {
                                        console.log(value)
                                        this.setState({ leader: value });
                                      }}

                                    >
                                      {this.state.employees.map(val => (
                                        <TreeNode value={val.id} title={val.fullname} key={val.id} />
                                      ))}
                                    </TreeSelect>
                                  </MDBCol>
                                </MDBRow>
                              </div>
                              <br></br>
                              <br></br>
                              <div className="text-center">
                                {this.state.actionType === "EDIT" &&
                                  <MDBBtn
                                    style={{ background: 'linear-gradient(135deg, #1D9598, #127275)', color: '#fff' }}
                                    rounded
                                    type="submit"
                                    className="btn-block z-depth-1a"
                                  >
                                    <MDBIcon icon="edit" className="mr-2" />
                                    {allStrings.update}
                                  </MDBBtn>
                                }
                              </div>
                            </form>
                          </MDBCol>

                        </MDBRow>
                      </MDBContainer>
                    </CardContent>
                  </Card>
                </div>
              </MDBCol>
            </MDBRow>
            {this.state.actionType === "VIEW" && this.membersTable()}
            {this.state.actionType === "VIEW" && this.salesTeamTargetsTable()}
          </MDBContainer>
        </Spin>
      </div>
    )
  }
}



const mapToStateProps = (state) => ({
  isRTL: state.lang.isRTL,
  currentUser: state.auth.currentUser,
});

const mapDispatchToProps = {
};

export default withRouter(
  connect(mapToStateProps, mapDispatchToProps)(SalesTeamInfo)
);